import { render, staticRenderFns } from "./AssetRegistries.vue?vue&type=template&id=440fcdc9&scoped=true&"
import script from "./AssetRegistries.vue?vue&type=script&lang=js&"
export * from "./AssetRegistries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440fcdc9",
  null
  
)

export default component.exports